import SelectedAccountModel from "./SelectedAccountModel";
export default class UserAccountsModel
{
	constructor(data:any){
    for(let acc of data){
        this.accounts.push(new SelectedAccountModel(acc))
    }
    }
    accounts:any=[]
} 